<template>
    <form class="kt-portlet" style="margin-top:1.5rem" data-vv-scope="form-1">
        <div class="container">
            <div class="kt-portlet__head-label" style="margin-top: 1rem; margin-bottom: 2rem;">
                <h5 class="kt-portlet__head-title text-center"><b>{{ titulo }}</b></h5>
            </div>

            <div class="form-group row">

                <div class="form-group col-md-6 col-12" >
                    <label class="true">Tipo de persona</label>
                    <combo-box 
                        style="border:1px solid #786c6c; border-radius: 4px;" 
                        v-model="formulario.tipoPersona"
                        :opciones="lstTipoPersona" 
                        name="Tipo de persona" />
                    <span class="form-text text-danger">{{ errors.first('form-1.tipoPersona') }}</span>
                </div>

                <div class="form-group col-md-6 col-12" >
                    <label class="true">*Tipo de documento</label>
                    <combo-box 
                        style="border:1px solid #786c6c; border-radius: 4px;" 
                        v-model="formulario.tipoDocumento"
                        :opciones="lstDocumentos" 
                        name="Tipo de documento" />
                    <span class="form-text text-danger">{{ errors.first('form-1.tipoDocumento') }}</span>
                </div>

                <div class="form-group col-md-6 col-12">
                    <label class="true">*Número de documento</label>
                    <input 
                        type="text" 
                        style="text-transform:uppercase;border:1px solid #786c6c;" 
                        class="form-control"
                        placeholder="" 
                        name="ci"
                        id="cédula" 
                        autoFocus
                        v-validate="{required:true,numeric:false, max: formulario.docMax}"
                        v-model="formulario.ci"
                        :maxlength="formulario.docMax"
                        />
                        <span class="form-text text-danger" v-if="errors.first('form-1.ci') && formulario.tipoDocumento.dt1"> Documento {{formulario.tipoDocumento.dt1}} obligatorio</span>
                        <span class="form-text text-danger" v-if="formulario.ci === null || formulario.ci.trim() === ''">
                            {{ formulario.nombreDoc }}
                        </span>

                        <span class="form-text text-danger" v-if="msnError">
                            {{ msnError }}
                        </span>

                        <span class="form-text text-danger" v-if="formulario.ci != null && formulario.ci.trim() != '' && ( formulario.ci.length < formulario.docMin ||  formulario.ci.length > formulario.docMax)">
                            {{ "La longitud de documento debe estar en el rango "+formulario.docMin+" - " + formulario.docMax }}
                        </span>
                </div>

                <div class="form-group col-md-6 col-12" v-if="juridica">
                    <label class="true">Razón social</label>
                    <input 
                        type="text" 
                        style="text-transform:uppercase;border:1px solid #786c6c;" 
                        value=""
                        onkeyup="javascript:this.value=this.value.toUpperCase();" 
                        class="form-control" 
                        placeholder=""
                        name="razón social" 
                        v-validate="{ required: formulario.isRazonSocialRequied}"
                        v-model="formulario.razonSocial" />
                    <span class="form-text text-danger">{{ errors.first('form-1.razón social') }}</span>
                </div>


                <div class="form-group col-md-6 col-12" v-if="!juridica">
                    <label class="true">*Primer nombre</label>
                    <input 
                        type="text" 
                        style="text-transform:uppercase;border:1px solid #786c6c;" 
                        value=""
                        onkeyup="javascript:this.value=this.value.toUpperCase();" 
                        class="form-control" 
                        placeholder=""
                        name="nombre" 
                        v-validate="{ required: formulario.isNombreUnoRequired }"
                        v-model="formulario.nombreUno" />
                    <span class="form-text text-danger">{{ errors.first('form-1.nombre') }}</span>
                </div>

                <div class="form-group col-md-6 col-12" v-if="!juridica">
                    <label class="true">Segundo nombre</label>
                    <input 
                        type="text" 
                        style="text-transform:uppercase;border:1px solid #786c6c;" 
                        value=""
                        onkeyup="javascript:this.value=this.value.toUpperCase();" 
                        class="form-control" 
                        placeholder=""
                        name="nombre" v-model="formulario.nombreDos" />
                </div>


                <div class="form-group col-md-6 col-12" v-if="!juridica">
                    <label class="true">*Primer apellido</label>
                    <input 
                        type="text" 
                        style="text-transform:uppercase;border:1px solid #786c6c;" 
                        value=""
                        onkeyup="javascript:this.value=this.value.toUpperCase();" 
                        class="form-control" 
                        placeholder=""
                        name="apellido" 
                        v-validate="{ required: formulario.isApellidoUnoRequired }"
                        v-model="formulario.apellidoUno" />
                    <span class="form-text text-danger">{{ errors.first('form-1.apellido') }}</span>
                </div>

                <div class="form-group col-md-6 col-12" v-if="!juridica">
                    <label class="true">Segundo apellido</label>
                    <input 
                        type="text" 
                        style="text-transform:uppercase;border:1px solid #786c6c;" 
                        value=""
                        onkeyup="javascript:this.value=this.value.toUpperCase();" 
                        class="form-control" 
                        placeholder=""
                        name="apellido" v-model="formulario.apellidoDos" />
                </div>

                <div class="form-group col-md-6 col-12" >
                    <label class="true">Tipo teléfono</label>
                    <combo-box 
                        style="border:1px solid #786c6c;border-radius: 4px;" 
                        v-model="formulario.tipoTelefono"
                        :opciones="lstTipoTelefono" 
                        name="tipoTelefono" 
                        placeholder="" />
                    <span class="form-text text-danger">{{ errors.first('form-1.tipoTelefono') }}</span>
                </div>

                <div class="form-group col-md-6 col-12" >
                    <label class="true">*Número de teléfono</label>
                    <input 
                        style="border:1px solid #786c6c;" 
                        type="tel" 
                        class="form-control" 
                        placeholder=""
                        name="número de teléfono" 
                        :maxlength="formulario.maximoCateres"
                        v-validate="{ required: true, ...formulario.validacion, max: formulario.maximoCateres }"
                        v-model="formulario.numeroTelefono" />
                    <span class="form-text text-danger">{{ errors.first('form-1.número de teléfono') }}</span>
                </div>

                <div class="form-group col-md-6 col-12" >
                    <label class="true">*Correo electrónico</label>
                    <input 
                        v-model="formulario.email" 
                        class="form-control" 
                        style="border:1px solid #786c6c;"
                        v-validate="{ required: true, email: true, max: 50 }" name="correo electrónico"
                        placeholder="mail@mail.com.ec">
                    <span class="form-text text-danger">{{ errors.first('form-1.correo electrónico') }}</span>
                </div>

                <div class="kt-portlet">
                    <div class="container">
                        <label class="kt-checkbox kt-checkbox--tick kt-checkbox--brand" for="habeas">
                            <input type="checkbox" v-model="formulario.promo" v-validate="{ required: true }" name="promo"
                                id="habeas">
                            {{ msgEmail }}
                            <span></span>
                        </label>
                    </div>
                </div>

            </div>
        </div>
    </form>
</template>

<script>
import * as servicios from "../servicios";
import comboBox from "../componentes/comboBox.vue";
import constantes from "../constantes";

export default {
    nombre: "formularioGenerico",
    components: { comboBox },
    props: ['titulo'],

    data: () => ({
        lstDocumentos: [],
        lstTipoTelefono: [],
        lstTipoPersona: [],
        isJuridica: false,
        isRuc: false,
        tipoDocumentoAux: null,
        juridica: false,
        ruc: null,
        
        valTelf: constantes.Constantes.validacion,
        msgEmail: constantes.Constantes.emails,
        formulario: {
            tipoDocumento: { id: null },
            tipoTelefono: { id: null },
            tipoPersona: { id: null },
            ci: null,
            nombreUno: null,
            nombreDos: null,
            apellidoUno: null,
            apellidoDos: null,
            email: null,
            numeroTelefono: null,
            promo: false,
            maximoCateres: 0,
            validacion: {},
            razonSocial: null,
            docMax:0,
            docMin:0,
            nombre1: true,
            apellido1:true,

            isNombreUnoRequired: true,
            isApellidoUnoRequired: true,
            isRazonSocialRequied: false,
            nombreDoc:null,
        },
        
        msnError:null
        
    }),

    methods: {

        consultarTipoPersona: function () {
            servicios.tipoPersona.tipoPersona().then((response) => {
                this.lstTipoPersona = response.data;
                const aux = response.data.find((i) => i.dt1 === "NATURAL");
                this.formulario.tipoPersona = { id: aux.id, dt1: aux.dt1 };
            });
        },

      

        limpiarFormulario() {
            this.formulario.tipoDocumento = { id: null };
            this.formulario.tipoTelefono = { id: null };
            this.formulario.ci = null;
            this.formulario.nombreUno = null;
            this.formulario.nombreDos = null;
            this.formulario.apellidoUno = null;
            this.formulario.apellidoDos = null;
            this.formulario.email = null;
            this.formulario.numeroTelefono = null;
            this.formulario.promo = false;
            this.formulario.maximoCateres = 0;
            this.formulario.validacion = {};
            this.formulario.razonSocial = null;
            this.formulario.docMax = 0;
            this.formulario.docMin = 0;
            this.formulario.nombre1 = true;
            this.formulario.apellido1 = true;
        },

        updateNombreDoc() {
            if (this.formulario.tipoDocumento && this.formulario.tipoDocumento.dt1) {
                const docType = this.formulario.tipoDocumento.dt1;
                if (this.formulario.ci) {
                    this.nombreDoc = '';
                } else {
                    if (docType === 'CEDULA') {
                        this.nombreDoc = 'El número de cédula es requerido.';
                    } else if (docType === 'RUC') {
                        this.nombreDoc = 'El número de RUC es requerido.';
                    } else {
                        this.nombreDoc = 'Documento requerido.';
                    }
                }
            } else {
                this.nombreDoc = '';
            }
        },
  
    },



    mounted() {
        this.consultarTipoPersona();
        this.updateNombreDoc();
    },

    watch: {
        'formulario': {
            deep: true,
            handler: function () {
                this.$validator.validateAll('form-1').then((result) => {
                    if (result) {
                        this.$emit('input', this.formulario);
                    } else {
                        this.$emit('input', null);
                    }
                });
            }
        },

        "formulario.tipoTelefono": function (val) {
            if (val) {
                this.formulario.maximoCateres = val.ndt1;
                this.formulario.numeroTelefono = null;
                this.formulario.validacion = val.ndt1 === 10 ? this.valTelf.celular : this.valTelf.fijo
            }
        },

        "formulario.tipoPersona": function (val) {
            this.limpiarFormulario();
            if (val) {
                servicios.tipoDocumento.tipoDocumento(val.id).then((response) => {
                    const aux = response.data.find(i => i.dt1 === "CEDULA");
                    const aux2 = response.data.find(i => i.dt1 === "RUC");
                    this.juridica = val.dt1 === 'JURIDICA'
                    this.formulario.tipoDocumento = aux ? aux : aux2;
                    this.lstDocumentos = response.data;
                    

                    this.isNombreUnoRequired = val.dt1 === 'NATURAL';
                    this.isApellidoUnoRequired = val.dt1 === 'NATURAL';
                    this.isRazonSocialRequied = val.dt1 === 'JURIDICA';
                });

                servicios.tipoTelefono.tipoTelefono(val.dt1).then((response) => {
                    this.lstTipoTelefono = response.data.Result;
                    const auxTelf = response.data.Result.find(x => x.dt1 === 'PERSONAL');
                    const auxTelf2 = response.data.Result.find(x => x.dt1 === 'MOVIL TRABAJO');
                    this.formulario.tipoTelefono = auxTelf ? auxTelf : auxTelf2;
                });
            }
        },

        "formulario.tipoDocumento": function (val) {
            if (val) {
                this.formulario.docMax = val.ndt1;
                this.formulario.docMin = val.ndt2;
                this.formulario.ci = null; 
                this.msnError = ''
                this.updateNombreDoc(); 
            }
        },

        "formulario.ci": function(valor){
            this.msnError = ''
            if(valor){
                this.msnError = ''
                if(valor.length >= this.formulario.docMin && valor.length <= this.formulario.docMax ){
                    servicios.validacionDocumento.validacionDocumento(this.formulario).then((response) => {
                        this.$emit('docInval', response.data.bdt);
                    }).catch((error)=>{
                        this.msnError = error.response.data.dt1
                        this.$emit('docInval', false);
                    });
                }       
            }
            this.updateNombreDoc();
        }
    },



}
</script>

<style scoped></style>
